import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { VersionService } from '../version/version.service';

@Injectable({
  providedIn: 'root'
})
export class TranslationService {
  private translations: { [key: string]: string } = {};
  private currentLang: string = 'fr';

  constructor(private http: HttpClient, private versionService: VersionService) { }

  loadTranslations(lang: string): Promise<any> {
    const version = this.versionService.get();
    return this.http.get(`/assets/languages/${lang}.json?v=` + version).pipe(
      map((translations: any) => {
        this.translations = translations;
        this.currentLang = lang;
        return translations;
      }),
      catchError(() => {
        console.error(`Could not load translations for language: ${lang}`);
        return of({});
      })
    ).toPromise();
  }

  translate(key: string, params?: { [key: string]: any }): string {
    var phrase = this.translations[key] || key;

    if (params) {
      Object.keys(params).forEach((paramKey) => {
        phrase = phrase.replace(new RegExp(`\\{${paramKey}\\}`, 'g'), params[paramKey]);
      });
    }

    return phrase != "XXX" ? phrase :  key;
  }

  getCurrentLang(): string {
    return this.currentLang;
  }
}
